import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createSite = (site) => ({
  type: ActionTypes.SITE_CREATE,
  payload: {
    site,
  },
});

export const updateSite = (id, data) => ({
  type: ActionTypes.SITE_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteSite = (id) => ({
  type: ActionTypes.SITE_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createSiteRequested = (localId, data) => ({
  type: ActionTypes.SITE_CREATE_REQUESTED,
  payload: {
    localId,
    data,
  },
});

export const createSiteSucceeded = (localId, site, lines, labels) => ({
  type: ActionTypes.SITE_CREATE_SUCCEEDED,
  payload: {
    localId,
    site,
    lines,
    labels,
  },
});

export const createSiteFailed = (localId, error) => ({
  type: ActionTypes.SITE_CREATE_FAILED,
  payload: {
    localId,
    error,
  },
});

export const createSiteReceived = (site, lines, labels) => ({
  type: ActionTypes.SITE_CREATE_RECEIVED,
  payload: {
    site,
    lines,
    labels,
  },
});

export const fetchSiteRequested = (id) => ({
  type: ActionTypes.SITE_FETCH_REQUESTED,
  payload: {
    id,
  },
});

export const fetchSiteSucceeded = (
  site,
  labels,
  lines,
  devices,
  deviceMemberships,
  deviceLabels,
  alarms,
  attachments,
) => ({
  type: ActionTypes.SITE_FETCH_SUCCEEDED,
  payload: {
    site,
    labels,
    lines,
    devices,
    deviceMemberships,
    deviceLabels,
    alarms,
    attachments,
  },
});

export const fetchSiteFailed = (id, error) => ({
  type: ActionTypes.SITE_FETCH_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateSiteRequested = (id, data) => ({
  type: ActionTypes.SITE_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateSiteSucceeded = (site) => ({
  type: ActionTypes.SITE_UPDATE_SUCCEEDED,
  payload: {
    site,
  },
});

export const updateSiteFailed = (id, error) => ({
  type: ActionTypes.SITE_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateSiteReceived = (site) => ({
  type: ActionTypes.SITE_UPDATE_RECEIVED,
  payload: {
    site,
  },
});

export const deleteSiteRequested = (id) => ({
  type: ActionTypes.SITE_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteSiteSucceeded = (site) => ({
  type: ActionTypes.SITE_DELETE_SUCCEEDED,
  payload: {
    site,
  },
});

export const deleteSiteFailed = (id, error) => ({
  type: ActionTypes.SITE_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteSiteReceived = (site) => ({
  type: ActionTypes.SITE_DELETE_RECEIVED,
  payload: {
    site,
  },
});
